const Layout = r => require(['@/pages/PageLayout'], r)

/**
*		系统管理
*/

// 学生管理
const SystemStudent = r => require(['@/v3/modules/datamanage/views/account/student'], r)
const Student = r => require(['@/v3/modules/datamanage/views/system/student/index_xgk'], r) // 考试列表

// 教师管理
const SystemTeacher = r => require(['@/v3/modules/datamanage/views/system/teacher/index'], r)

// 班级管理
const SystemClass = r => require(['@/v3/modules/datamanage/views/system/class/index'], r)

// 基础参数管理
const SystemParmAbility = r => require(['@/v3/modules/datamanage/views/system/parm/ability'], r)	// 能力维护
const SystemParmLayout = r => require(['@/v3/modules/datamanage/views/param/index'], r) // 基础参数管理父路由
const SystemParmLevel = r => require(['@/v3/modules/datamanage/views/param/level'], r)		// 分数段等级
const SystemParmGradeSet = r => require(['@/v3/modules/datamanage/views/param/gradeSet'], r)	// 年级数据显示
const SystemParmKnowledge = r => require(['@/v3/modules/datamanage/views/param/knowledge'], r)// 知识点
const SystemParmUndulate = r => require(['@/v3/modules/datamanage/views/param/undulate'], r)	// 波动生
const SystemParmCount = r => require(['@/v3/modules/datamanage/views/param/special'], r)		// 参与统计
const SystemParmAverage = r => require(['@/v3/modules/datamanage/views/param/average'], r)	// 平均分设置
const SystemParmOther = r => require(['@/v3/modules/datamanage/views/param/other'], r) // 其他设置

// 角色管理
const SystemRole = r => require(['@/v3/modules/datamanage/views/system/role/index'], r)

export default {
  path: '/system',
  component: Layout,
  meta: { auth: 'System' },
  children: [
    {
      path: '/system/student',
      name: 'SystemStudent',
      meta: { auth: ['System-Student', 'Student-Management'], keepAlive: true },
      component: SystemStudent
    },
    {
      path: '/system/student/xgk',
      name: 'SystemStudentXgk',
      component: Student,
      meta: { auth: ['System-Student', 'Student-Management'], keepAlive: true }
    },
    {
      path: '/system/role',
      name: 'SystemRole',
      meta: { auth: ['System-Role', 'Role-Management'] },
      component: SystemRole
    },
    {
      path: '/system/class',
      name: 'SystemClass',
      meta: { auth: ['System-Class', 'Class-Management'] },
      component: SystemClass
    },
    {
      path: '/system/teacher',
      name: 'SystemTeacher',
      meta: { auth: ['System-Teacher', 'Teacher-Management'], keepAlive: true },
      component: SystemTeacher
    },
    {
      // 基础参数管理
      path: '/system/parm',
      name: 'SystemParm',
      component: SystemParmLayout,
      meta: { auth: ['System-Parm', 'System-Parm-Management'] },
      children: [
        {
          path: '/system/parm/level',
          name: 'SystemParmLevel',
          meta: { auth: ['System-Parm-Level', 'System-Parm-Management'] },
          component: SystemParmLevel
        },
        {
          path: '/system/parm/knowledge',
          name: 'SystemParmKnowledge',
          meta: { auth: ['System-Parm-Knowledge', 'System-Parm-Management'] },
          component: SystemParmKnowledge
        },
        {
          path: '/system/parm/undulate',
          name: 'SystemParmUndulate',
          meta: { auth: ['System-Parm-Undulate', 'System-Parm-Management'] },
          component: SystemParmUndulate
        },
        {
          path: '/system/parm/count',
          name: 'SystemParmCount',
          meta: { auth: ['System-Parm-Count', 'System-Parm-Management'] },
          component: SystemParmCount
        },
        {
          path: '/system/parm/ability',
          name: 'SystemParmAbility',
          meta: { auth: ['System-Parm-Ability', 'System-Parm-Management'] },
          component: SystemParmAbility
        },
        {
          path: '/system/parm/average',
          name: 'SystemParmAverage',
          meta: { auth: ['System-Parm-Average', 'System-Parm-Management'] },
          component: SystemParmAverage
        },
        {
          path: '/system/parm/gradeSet',
          name: 'SystemParmGradeSet',
          meta: { auth: ['System-Parm-GradeSet', 'System-Parm-Management'] },
          component: SystemParmGradeSet
        },
        {
          path: '/system/parm/other',
          name: 'SystemParmOther',
          meta: { auth: ['System-Parm-Other', 'System-Parm-Management'] },
          component: SystemParmOther
        }
      ]
    }
  ]
}
